module.exports = __webpack_public_path__ + "static/media/cohete.1f933b3c.svg";